/**
 * Soft launch access PIN — client-side only (not real security).
 * Same facility as HOTTR.tv: 24h unlock, env-driven code, legacy fallback.
 */

const LEGACY_SITE_PIN = '071179';

export const PIN_TTL_MS = 24 * 60 * 60 * 1000;

const KEY = 'hottr.me.pin_ok_v1';

export function getConfiguredPin(): string {
  const fromVite =
    typeof import.meta !== 'undefined' &&
    typeof import.meta.env?.VITE_PIN_ACCESS_CODE === 'string'
      ? import.meta.env.VITE_PIN_ACCESS_CODE
      : '';
  const fromDefine =
    typeof __PIN_ACCESS_CODE__ !== 'undefined' ? String(__PIN_ACCESS_CODE__ || '') : '';
  const raw = (fromDefine || fromVite || LEGACY_SITE_PIN).replace(/\s/g, '');
  return raw || LEGACY_SITE_PIN;
}

export function isPinUnlocked(): boolean {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const unlockedAt = Number(raw);
    if (!Number.isFinite(unlockedAt) || unlockedAt <= 0) {
      localStorage.removeItem(KEY);
      return false;
    }
    const age = Date.now() - unlockedAt;
    if (age < 0 || age >= PIN_TTL_MS) {
      localStorage.removeItem(KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function pinUnlockRemainingMs(): number {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return 0;
    const unlockedAt = Number(raw);
    if (!Number.isFinite(unlockedAt)) return 0;
    return Math.max(0, PIN_TTL_MS - (Date.now() - unlockedAt));
  } catch {
    return 0;
  }
}

export function unlockPin(): void {
  try {
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function lockPin(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function checkPin(value: string): boolean {
  return value.replace(/\s/g, '') === getConfiguredPin();
}

declare const __PIN_ACCESS_CODE__: string | undefined;
